import { configureStore } from "@reduxjs/toolkit";

import authSlice from "./slice/authSlice";

import searchAppListReducer from './slice/search_applist_slice';
import appsDashboardReducer from './slice/apps_dashboard_slice';
import appDetailReducer from './slice/app_detail_slice';
import isAudience_Activate from './slice/audience_activate'


const store = configureStore({
  reducer: {
    auth: authSlice,
    searchAppList: searchAppListReducer,
    appsDashboard: appsDashboardReducer,
    appDetail: appDetailReducer,
    active: isAudience_Activate, 
  },
});

export default store;
